// Base File
const base = (api) => {
    return {
        api: api,
        isMock: false
    };
}
export default base;